
export enum Status {

    TRANSACTION_NEW = 101,
    TRANSACTION_CHARGED = 105,
    TRANSACTION_PARTIALLY_PAID = 118,
    TRANSACTION_FULLY_PAID_PENDING_ACKNOWLEDGEMENT = 109,

}
